<template>
    <section class="spare-part-kits">
        <p class="spare-part-kits__notice" v-if="notice" v-html="notice"></p>
        <div class="filter-section"
            v-if="pumpSeriesFacets.length > 0 || pumpSizesFacets.length > 0 || pumpDesignsFacets.length > 0">
            <div class="filter-items">
                <div class="filter-item filter-item--mw" v-if="pumpSeriesFacets.length > 0 && !preselectedPumpSeriesFacet">
                    <label class="sr-only"
                                for="pumpSeriesFilter">{{ dictionaries.SparePartKitsPumpSeriesFacetDefault }}</label>
                    <select id="pumpSeriesFilter" name="pumpSeriesFilter" :disabled="isLoading" v-model="pumpSeries" class="filter-item__select">
                        <option value="All">{{ dictionaries.SparePartKitsPumpSeriesFacetDefault }}</option>
                        <option :value="pumpSeries.Key" v-for="(pumpSeries, index) in pumpSeriesFacets"
                            v-if="pumpSeries.Name">
                            {{ pumpSeries.Name }}</option>
                    </select>
                </div>
                <div class="filter-item filter-item--mw"
                    v-if="pumpSizesFacets.length > 0 && pumpSeries !== 'All' && !preselectedPumpSizeFacet">
                    <label class="sr-only"
                                for="pumpSizeFilter">{{ dictionaries.SparePartKitsPumpSizeFacetDefault }}</label>
                    <select id="pumpSizeFilter" name="pumpSizeFilter" :disabled="isLoading" v-model="pumpSize" class="filter-item__select">
                        <option value="All">{{ dictionaries.SparePartKitsPumpSizeFacetDefault }}</option>
                        <option :value="pumpSize.Key" v-for="(pumpSize, index) in pumpSizesFacets" v-if="pumpSize.Name">{{
                            pumpSize.Name }}</option>
                    </select>
                </div>
                <div class="filter-item filter-item--mw"
                    v-if="pumpDesignsFacets.length > 0 && pumpSize != 'All' && !preselectedPumpDesignFacet">
                    <label class="sr-only"
                                for="pumpDesignFilter">{{ dictionaries.SparePartKitsPumpDesignFacetDefault }}</label>
                    <select id="pumpDesignFilter" name="pumpDesignFilter" :disabled="isLoading" v-model="pumpDesign" class="filter-item__select">
                        <option value="All">{{ dictionaries.SparePartKitsPumpDesignFacetDefault }}</option>
                        <option :value="pumpDesign.Key" v-for="(pumpDesign, index) in pumpDesignsFacets"
                            v-if="pumpDesign.Name">{{ pumpDesign.Name }}
                        </option>
                    </select>
                </div>
                <div class="filter-item" v-if="showResultSet && !hasPredefinedFacets">
                    <button type="button" class="filter-item__button" @click="resetFilter" :disabled="isLoading">{{
                        dictionaries.SparePartKitsFilterReset }}</button>
                </div>
            </div>
        </div>
        <!-- Spare Part Kits list -->
        <div class="spare-part-kits__list" v-show="sparePartKits.length && showResultSet">
            <SparePartKitItem v-for="sparePartKit in sparePartKits" :key="sparePartKit.Id" :sparePartKit="sparePartKit"
                :buttonText="dictionaries.SparePartKitsDownloadPdfButtonLabel"></SparePartKitItem>
        </div>
        <!-- Preselected Spare Part Kits list -->
        <div class="spare-part-kits__list" v-show="showpreselectedSparePartKits">
            <SparePartKitItem v-for="sparePartKit in preselectedSparePartKits" :key="sparePartKit.Id"
                :sparePartKit="sparePartKit" :buttonText="dictionaries.SparePartKitsDownloadPdfButtonLabel">
            </SparePartKitItem>
        </div>

        <div class="spare-part-kits__no-result" v-show="!sparePartKits.length && !isLoading && showResultSet">
            {{ dictionaries.SparePartKitsNoResult }}</div>
        <div class="spare-part-kits__cta" v-show="hasMoreSparePartKitsToLoad && showResultSet">
            <a @click="getNextPage" :disabled="isLoading" class="spare-part-kits__load-more">{{
                dictionaries.SparePartKitsLoadMore }}</a>
        </div>
    </section>
</template>

<script>
import { bindRoute } from "./mixins/bindroute.js";
import SparePartKitItem from './components/sparePartKitItem.vue';

const defaultPage = 1;
const defaultPumpSeriesFacet = "All";
const defaultPumpSizeFacet = "All";
const defaultPumpDesignFacet = "All";

export default {
    name: "sparePartKits",
    components: {
        SparePartKitItem
    },
    data() {
        return {
            dictionaries: [],
            pumpSeriesFacets: [],
            pumpSizesFacets: [],
            pumpDesignsFacets: [],
            sparePartKits: [],
            pageSize: 15,
            totalSparePartKits: 0,
            isLoading: false,
            rootNodeId:null,
            preselectedPumpSeriesFacet: null,
            preselectedPumpSizeFacet: null,
            preselectedPumpDesignFacet: null,
            preselectedSparePartKits: null,
            notice: null
        };
    },
    created() {
        const vm = this;

        vm.rootNodeId = vm.$parent.rootNodeId;
        
        const preselectedPumpSeriesFacet = vm.$parent.preselectedPumpSeriesFacet;
        if (preselectedPumpSeriesFacet) {
            vm.preselectedPumpSeriesFacet = preselectedPumpSeriesFacet;
            vm.pumpSeries = vm.preselectedPumpSeriesFacet;
        }

        const preselectedPumpSizeFacet = vm.$parent.preselectedPumpSizeFacet;
        if (preselectedPumpSizeFacet) {
            vm.preselectedPumpSizeFacet = preselectedPumpSizeFacet;
            vm.pumpSize = vm.preselectedPumpSizeFacet;
        }

        const preselectedPumpDesignFacet = vm.$parent.preselectedPumpDesignFacet;
        if (preselectedPumpDesignFacet) {
            vm.preselectedPumpDesignFacet = preselectedPumpDesignFacet;
            vm.pumpDesign = vm.preselectedPumpDesignFacet;
        }

        vm.notice = vm.$parent.notice;

        const preselectedSparePartKits = vm.$parent.preselectedSparePartKits;
        if (preselectedSparePartKits) {
            const languageCode = $("html").attr("lang");
            var object = {
                rootNodeId:vm.rootNodeId,
                sparePartKitIndexes: JSON.parse(preselectedSparePartKits),
                languageCode: languageCode,
            };
            $.get("/umbraco/api/sparePartKitsApi/GetSparePartKitsById", object, function (response) {
                vm.preselectedSparePartKits = response;
            }).fail(function (error) {
                console.log(error);
            });
        }

        vm.getInitialSparePartKits();
    },
    mixins: [
        bindRoute({
            page: defaultPage,
            pumpSeries: defaultPumpSeriesFacet,
            pumpSize: defaultPumpSizeFacet,
            pumpDesign: defaultPumpDesignFacet,
        })
    ],
    watch: {
        pumpSeries: {
            handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.pumpSize = defaultPumpSizeFacet;
                    this.pumpDesign = defaultPumpDesignFacet;
                    this.filterChanged();
                }
            }
        },
        pumpSize: {
            handler(newVal, oldVal) {
                if (newVal != oldVal && !this.isLoading) {
                    this.pumpDesign = defaultPumpDesignFacet;
                    this.filterChanged();
                }
            }
        },
        pumpDesign: {
            handler(newVal, oldVal) {
                if (newVal != oldVal && !this.isLoading) {
                    this.filterChanged();
                }
            }
        }
    },
    methods: {
        getSparePartKits(amountToSkip, pageSize) {
            const vm = this;
            vm.isLoading = true;
            vm.toggleSpinner(true);

            const languageCode = $("html").attr("lang");
            var object = {
                rootNodeId: vm.rootNodeId,
                languageCode: languageCode,
                amountToSkip: amountToSkip,
                pageSize: pageSize
            };
            if (vm.pumpSeries != defaultPumpSeriesFacet) {
                object.pumpSeries = vm.pumpSeries;
            }
            if (vm.pumpSize != defaultPumpSizeFacet) {
                object.pumpSize = vm.pumpSize;
            }
            if (vm.pumpDesign != defaultPumpDesignFacet) {
                object.pumpDesign = vm.pumpDesign;
            }

            $.get("/umbraco/api/sparePartKitsApi/getSparePartKits", object, function (response) {
                vm.dictionaries = response.Dictionaries;
                vm.pumpSeriesFacets = response.Facets.PumpSeries;
                vm.pumpSizesFacets = response.Facets.PumpSizes;
                vm.pumpDesignsFacets = response.Facets.PumpDesigns;
                vm.sparePartKits.push(...response.Items);
                vm.totalSparePartKits = response.TotalItems;
            }).fail(function (error) {
                console.log(error);
            }).always(function () {
                vm.isLoading = false;
                vm.toggleSpinner(false);
            });
        },
        getNextPage() {
            if (!this.isLoading) {
                this.page++;
                this.getSparePartKits(this.pageSize * (this.page - 1), this.pageSize);
            }
        },
        getInitialSparePartKits() {
            // Get all products up to, and including, the current page
            const initialPageSize = this.pageSize * this.page;
            this.getSparePartKits(0, initialPageSize);
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            if (isLoading) {
                $("body").addClass("is-loading");
            } else {
                $("body").removeClass("is-loading");
            }
        },
        filterChanged() {
            this.sparePartKits = [];
            this.totalSparePartKits = 0;
            this.page = defaultPage;
            this.getSparePartKits(0, this.pageSize);
        },
        resetFilter() {
            this.sparePartKits = [];
            this.totalSparePartKits = 0;
            this.page = defaultPage;
            this.pumpSeries = this.preselectedPumpSeriesFacet ? this.preselectedPumpSeriesFacet : defaultPumpSeriesFacet;
            this.currentPumpSeries = this.pumpSeries;
            this.pumpSize = this.preselectedPumpSizeFacet ? this.preselectedPumpSizeFacet : defaultPumpSizeFacet;
            this.currentPumpSize = this.pumpSize;
            this.pumpDesign = this.preselectedPumpDesignFacet ? this.preselectedPumpDesignFacet : defaultPumpDesignFacet;
            this.getSparePartKits(0, this.pageSize);
        }
    },
    computed: {
        hasMoreSparePartKitsToLoad() {
            return this.totalSparePartKits !== 0 && this.sparePartKits.length < this.totalSparePartKits;
        },
        showResultSet() {
            return this.pumpSeries != 'All' || this.pumpSize != 'All' || this.pumpDesign != 'All'
        },
        showpreselectedSparePartKits() {
            return !this.showResultSet && this.preselectedSparePartKits != null && this.preselectedSparePartKits.length > 0;
        },
        hasPredefinedFacets() {
            return this.preselectedPumpSeriesFacet != null || this.preselectedPumpSizeFacet != null || this.preselectedPumpDesignFacet != null;
        }
    }
};
</script>